import React, { useEffect, useRef, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import DateUtil from '../utils/DateUtil'
import PersonnelList from '../components/personnel-list/PersonnelList'
import DeskReservation from '../components/desk-reservation/DeskReservation'
import { IDesk } from '../types/DeskType'
import { ISelectBox } from '../types/MainType'
import { IEmployeeSummary } from '../types/Employee'
import {
  IFloorFilteredDeskListRequest,
  IFloorProperties,
  IFloorPropertiesGroup,
  IFloorTemplate,
  ReservationMeta,
} from '../types/FloorType'
import { EmployeeList, ICapacity, IReservationList, IReservationListRequest } from '../types/Reservation'
import DeskService from '../service/DeskService'
import FloorService from '../service/FloorService'
import EmployeeService from '../service/EmployeeService'
import FavoritesService from 'service/FavoritesService'
import ReservationService from '../service/ReservationService'
import { Button } from 'primereact/button'
import { IFloorMessage } from '../types/FloorMessageType'
import { PlanTabs } from '../types/PlanTabs'
import Private from './Private'
import { Helmet } from 'react-helmet'
import { Checkbox } from 'primereact/checkbox'
import { OverlayPanel } from 'primereact/overlaypanel'
import SharedOfficeService from '../service/SharedOfficeService'
import { SharedOfficeRequest } from '../types/SharedOffice'
import SharedOfficeModal from '../components/ui/modal/SharedOfficeModal'
import { Toast } from 'primereact/toast'
import ReservationTab from '../components/home/ReservationTab'
import { useTranslation } from 'react-i18next'
import FavoriteIconButton from 'components/ui/FavoriteIconButton'
import AuthUtil from 'utils/AuthUtil'

const Reservation = () => {
  const location = useLocation()
  const { t } = useTranslation()
  //Search Bardan Gönderilen Parametreler
  const [state, setState] = useState<{ response: ReservationMeta }>(location.state as { response: ReservationMeta })

  const [selectEmployee, setSelectEmployee] = useState<EmployeeList>() //Soldaki Kişi Listesinden Seçilen Kişi
  const [personnelList, setPersonnelList] = useState<EmployeeList[]>()

  const [employee, setEmployee] = useState<IEmployeeSummary>() //Login Olan Kullanıcı
  const [floorTemplate, setFloorTemplate] = useState<IFloorTemplate>() //Kat Planı
  const [deskList, setDeskList] = useState<IDesk[]>([]) // Kattaki Masaların Bilgisi
  const [mapsURL, setMapURL] = useState<string>() // Seçili Olan Katın Haritadaki Konumu
  const [loading, setLoading] = useState<boolean>(false)
  const [selectedFloorId, setSelectedFloorId] = useState(state?.response?.selectedFloor?._id)
  const [currentFloorId, setCurrentFloorId] = useState<number>(-1)
  const [myReservation, setMyReservation] = useState<boolean>(false)
  const [tableProperties, setTableProperties] = useState<IFloorProperties[]>([])

  const [capacity, setCapacity] = useState<ICapacity[]>()
  const [reservationList, setReservationList] = useState<IReservationList[]>()

  const [isShowMessage, setIsShowMessage] = useState<boolean>()
  const [dayList, setDayList] = useState<string[] | undefined>()
  const [messageTr, setMessageTr] = useState<string>()
  const [visible, setVisible] = useState(false)
  const [modalText, setModalText] = useState<IFloorMessage | undefined>()

  const [form, setForm] = useState<ReservationMeta>(state?.response)
  const [reservationListRequest, setReservationListRequest] = useState<IReservationListRequest>({
    floorId: selectedFloorId,
    isMyFirm: true,
    isPeersAndTeamMembers: true,
    reservationDate: DateUtil.formatDateToString(state?.response.startDate),
    reservationEndDate: DateUtil.formatDateToString(state?.response.endDate),
  })
  const [bannerDisabledButton, setBannerDisabledButton] = useState<boolean>(false)
  const [floorCalendarVisible, setFloorCalendarVisible] = useState<boolean>(false)
  const [floorCalendarMessage, setFloorCalendarMessage] = useState<string>()
  const [floorDayList, setFloorDayList] = useState<string[] | undefined>()
  const [floorShowMessage, setFloorShowMessage] = useState<boolean>()

  const ToastMessage = useRef<any>(null)
  const history = useHistory()

  useEffect(() => {
    if (state === undefined) {
      history.push({
        pathname: '/home',
      })
    }
    let item = localStorage.getItem('employee')
    if (item !== null) {
      setEmployee(JSON.parse(item) as IEmployeeSummary)
    }
  }, [])
  useEffect(() => {
    if (state?.response.selectedFloor) {
      if (state.response.selectedFloor.locationMapsUrl) {
        if (state.response.selectedFloor.locationMapsUrl.includes('src')) {
          setMapURL(state.response.selectedFloor.locationMapsUrl.split('src')[1].split('width')[0].split('"')[1])
        } else {
          setMapURL('')
        }
      }
      getFloorMessage(reservationListRequest.floorId!)
      getReservationList(reservationListRequest!)
      tablePropertiesByFloorId(reservationListRequest.floorId!)
      floorAllProperties(reservationListRequest.floorId!)
    }
  }, [reservationListRequest])
  const getFloorMessage = (floorId: number) => {
    FloorService.getFloorMessageById(floorId).then((response) => {
      setModalText(response.data)
    })
  }

  const getReservationList = async (request: IReservationListRequest) => {
    setLoading(true)
    if (!state.response.selectedFloor.isReservable) {
      await ReservationService.getReservationList(request)
        .then((response) => {
          setAllUserList(response.data) // Rezervasyonları İçerisinden Kişi Listesini Oluşturulur
          getDeskList(response.data) // Masa Bilgilerinin İçine Masaya Ait Rezervasyonlar Eklenir
          setReservationList(response.data)
        })
        .catch((e) => {
          console.log(e)
        })
    } else {
      await ReservationService.getFloorReservationList(request)
        .then((response) => {
          setAllUserList(response.data.reservationList!)
          setCapacity(response.data.capacityList) // Rezervasyonları İçerisinden Kişi Listesini Oluşturulur
          getDeskList(undefined!)
          setLoading(false)
        })
        .catch((e) => {
          console.log(e)
        })
    }
  }

  const showBottomRight = () => {
    ToastMessage.current.show({
      severity: 'success',
      summary: t('success-text.success'),
      detail: t('success-text.table-filter'),
      life: 3000,
    })
  }

  // Rezervayonların İçerisinden Rezervasyon Yapan Kişilerin Listesi Oluşturulur
  const setAllUserList = (reservationList: IReservationList[]) => {
    let item = localStorage.getItem('employee')
    let loginEmployee: IEmployeeSummary
    if (item !== null) {
      loginEmployee = JSON.parse(item) as IEmployeeSummary
    }
    let employeeList: EmployeeList[] = []
    setMyReservation(false)
    reservationList.map((reservation) => {
      if (!myReservation && reservation.employeeId === loginEmployee?.id) {
        setMyReservation(true)
      }
      if (employeeList.findIndex((employee) => employee.employee?.employeeId === reservation.employeeId) === -1) {
        let tempEmployee: EmployeeList = { employee: undefined, reservationList: [] }
        tempEmployee.employee = {
          employeeFullName: reservation.employeeFullName,
          employeePhoto: EmployeeService.getEmployeePhotoUrlById(reservation.employeeId),
          employeeId: reservation.employeeId,
          employeePositionName: reservation.employeePositionName,
          isMyFirmReservation: reservation.isMyFirmReservation,
          isMyTeamReservation: reservation.isMyTeamReservation,
          isPeerOrTeamMemberReservation: reservation.isPeerOrTeamMemberReservation,
          isSelfReservation: reservation.isSelfReservation,
        }
        tempEmployee.reservationList = reservationList.filter((x) => x.employeeId === tempEmployee.employee?.employeeId)
        employeeList.push(tempEmployee)
      }
    })
    setPersonnelList(employeeList)
  }

  // Masaların Listesi ve Bu Liste İçerisine O Masaya Ait Rezervasyonlar Eklenir
  const getDeskList = (reservationList: IReservationList[]) => {
    DeskService.getDeskList(selectedFloorId)
      .then((response) => {
        response.data?.map((deskList) => {
          deskList.listTable?.map((table) => {
            // #my-reservation #available #reserved  #crew #team  #reserved-closed ^#unavailable
            // Rezerve Edilecek Masa Uygun
            if (table.isActive && table.isAuth && !table.isUnavailable) {
              if (reservationList.filter((reservation) => reservation.tableId === table.id)[0] === undefined) {
                table._status = 'available'
              } else {
                // Tek Gün Rezervasyon
                if (state.response.startDate.getTime() === state.response.endDate.getTime()) {
                  let reservation = reservationList.filter((reservation) => reservation.tableId === table.id)[0]
                  reservation.isSelfReservation
                    ? (table._status = 'my-reservation')
                    : !reservation.isMyTeamReservation && reservation.isPeerOrTeamMemberReservation
                    ? (table._status = 'team')
                    : reservation.isMyTeamReservation
                    ? (table._status = 'crew')
                    : reservation.isMyFirmReservation
                    ? (table._status = 'reserved')
                    : !reservation.isMyFirmReservation &&
                      !reservation.isPeerOrTeamMemberReservation &&
                      !reservation.isMyTeamReservation &&
                      !reservation.isSelfReservation
                    ? (table._status = 'reserved')
                    : (table._status = 'reserved-closed')
                }
                // Çoklu Gün Rezervasyon
                else {
                  table._status = 'reserved'
                }
              }
            }
            // Rezerve Edilecek Masa Uygun Değil
            else {
              let reservation = reservationList.filter((reservation) => reservation.tableId === table.id)
              reservation.length > 0 ? (table._status = 'reserved') : (table._status = 'unavailable')
            }

            table._reservation = reservationList.filter((reservation) => reservation.tableId === table.id)
          })
        })
        setDeskList(response.data)
      })
      .then(async () => {
        await getFloorTemplate()
        if (currentFloorId !== selectedFloorId) {
          setCurrentFloorId(selectedFloorId)
        }
        setLoading(false)
      })
      .catch((e) => {
        console.log(e)
      })
  }
  const getFloorTemplate = async () => {
    console.log('getFloorTemplate called with selectedFloorId:', selectedFloorId)
    try {
      const response = await FloorService.getFloorTemplate(selectedFloorId)
      console.log('Floor Template Response:', response.data)
      setFloorTemplate(response.data)
    } catch (e) {
      console.error('Floor Template Error:', e)
    }
  }

  const changeFloor = (e: ISelectBox) => {
    setSelectedFloorId(e.id)
    setReservationListRequest((prevState) => {
      return { ...prevState, floorId: e.id }
    })
  }
  const getSharedCheckAvaible = async () => {
    let request: SharedOfficeRequest = {
      floorId: form?.selectedFloor._id,
      startDate: DateUtil.formatDateToString(form?.startDate),
      endDate: DateUtil.formatDateToString(form?.endDate),
    }
    await SharedOfficeService.getCheckFloorIsAvailable(request)
      .then((response) => {
        FloorService.getFloorCalendarDaysAvailable(request).then((floorResponse) => {
          if (floorResponse.data.showMessage || response.data.showMessage) {
            if (!floorResponse.data.showMessage && response.data.showMessage) {
              setIsShowMessage(true)
              setMessageTr(response.data.responseMessageTR)
              setVisible(true)
              setDayList(response.data?.dayList)
            } else if (floorResponse.data.showMessage && !response.data.showMessage) {
              setFloorShowMessage(true)
              setFloorCalendarMessage(floorResponse.data.responseMessageTR)
              setFloorCalendarVisible(true)
              setFloorDayList(floorResponse.data?.dayList)
            } else {
              setIsShowMessage(true)
              setMessageTr(response.data.responseMessageTR)
              setVisible(true)
              setDayList(response.data?.dayList)
            }
          } else {
            setSelectedFloorId(form?.selectedFloor._id!)
            setState({ response: form! })
            setSearch(!search)
            setReservationListRequest({
              floorId: form?.selectedFloor._id,
              isMyFirm: form?.planTab === PlanTabs.OFFICE,
              isPeersAndTeamMembers: true,
              reservationDate: DateUtil.formatDateToString(form?.startDate!),
              reservationEndDate: DateUtil.formatDateToString(form?.endDate!),
            })
          }
        })
      })
      .catch((e) => {
        console.log('error', e)
      })
  }

  const [search, setSearch] = useState<boolean>(false)
  const searchFloor = async () => {
    await getSharedCheckAvaible()
  }

  const tablePropertiesByFloorId = (floorId: number) => {
    FloorService.getTablePropertiesByFloorId(floorId).then((response) => {
      setTableProperties(response.data)
    })
  }
  const opProperties = useRef<OverlayPanel>(null)
  const [allFloorProperties, setAllFloorProperties] = useState<IFloorPropertiesGroup | undefined>(undefined)
  const floorAllProperties = (floorId: number) => {
    FloorService.getAuthAllProperties(floorId).then((response) => {
      let _allFloorProperties = response.data.reduce(function (r, a) {
        r[a.type] = r[a.type] || []
        r[a.type].push(a)
        return r
      }, Object.create(null))
      setAllFloorProperties(_allFloorProperties)
    })
  }
  const saveFilter = () => {
    let request: IFloorFilteredDeskListRequest = {
      floorId: selectedFloorId,
      tablePropIdList: selectedPropertyList.map((property: { id: any }) => property.id),
    }
    FloorService.getFilteredDeskList(request).then((response) => {
      response.data?.map((deskList) => {
        deskList.listTable?.map((table) => {
          // #my-reservation #available #reserved  #crew #team  #reserved-closed ^#unavailable
          // Rezerve Edilecek Masa Uygun
          if (table.isActive && table.isAuth && !table.isUnavailable) {
            if (reservationList?.filter((reservation) => reservation.tableId === table.id)[0] === undefined) {
              table._status = 'available'
            } else {
              // Tek Gün Rezervasyon
              if (state.response.startDate.getTime() === state.response.endDate.getTime()) {
                let reservation = reservationList.filter((reservation) => reservation.tableId === table.id)[0]
                reservation.isSelfReservation
                  ? (table._status = 'my-reservation')
                  : !reservation.isMyTeamReservation && reservation.isPeerOrTeamMemberReservation
                  ? (table._status = 'team')
                  : reservation.isMyTeamReservation
                  ? (table._status = 'crew')
                  : reservation.isMyFirmReservation
                  ? (table._status = 'reserved')
                  : !reservation.isMyFirmReservation &&
                    !reservation.isPeerOrTeamMemberReservation &&
                    !reservation.isMyTeamReservation &&
                    !reservation.isSelfReservation
                  ? (table._status = 'reserved')
                  : (table._status = 'reserved-closed')
              }
              // Çoklu Gün Rezervasyon
              else {
                table._status = 'reserved'
              }
            }
          }
          // Rezerve Edilecek Masa Uygun Değil
          else {
            table._status = 'unavailable'
          }

          table._reservation = reservationList?.filter((reservation) => reservation.tableId === table.id)!
        })
      })
      setDeskList(response.data)
      showBottomRight()
    })
  }

  const showProperties = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!opProperties?.current?.state?.visible) {
      opProperties.current?.toggle(e, e.target)
    }
  }

  const hideProperties = (e: React.MouseEvent<HTMLDivElement>) => {
    opProperties?.current?.hide()
  }

  const setBannerForm = (meta: ReservationMeta | undefined) => {
    setForm(meta!)
    if (meta?.selectedFloor !== undefined && typeof meta?.selectedFloor === 'object') {
      setFavorite(meta?.selectedFloor?.isFavorite!)
      setSelectedFloorId(meta?.selectedFloor?._id!)
      setBannerDisabledButton(false)
    } else {
      setBannerDisabledButton(true)
    }
  }

  useEffect(() => {
    if (form?.selectedFloor === null) {
      setBannerDisabledButton(true)
    }
  }, [form])

  const [selectedPropertyList, setSelectedPropertyList] = useState<any>([])

  const heightCalc = () => {
    let floor = document.getElementById('of-filter')
    let divHeight = floor?.offsetHeight
    return divHeight
  }

  const onPropertyChange = (e: { value: any; checked: boolean }, state: any, setState: React.Dispatch<any>) => {
    let _selectedCategories = [...state]
    if (e.checked) {
      _selectedCategories.push(e.value)
    } else {
      for (let i = 0; i < _selectedCategories.length; i++) {
        const selectedCategory = _selectedCategories[i]
        if (selectedCategory.Id === e.value.Id) {
          _selectedCategories.splice(i, 1)
          break
        }
      }
    }
    setState(_selectedCategories)
  }

  const getPlanTabNum = () => {
    return state.response.planTab
  }

  /* Favorite Location */
  const [favorite, setFavorite] = useState(state?.response?.selectedFloor?.isFavorite)
  const handleAddFavorite = () => {
    FavoritesService.saveFavoriteLocation(selectedFloorId).then((r) => setFavorite(true))
  }
  const handleRemoveFavorite = () => {
    FavoritesService.removeFavoriteLocation(selectedFloorId).then((r) => setFavorite(false))
  }

  return (
    <Private>
      <Helmet>
        <title>Koç Office Free -{t('most-used-words.reservation')}</title>
        <meta
          name="description"
          content="Rezervasyon ekranından seçtiğin kattaki tüm kişileri ve detayları görebilir, istediğin masayı seçebilirsin"
        />
      </Helmet>

      {state && (
        <div className={'container'}>
          <Toast ref={ToastMessage} position="bottom-right" />
          <div className={'mt-3 mb-3 pt-4 pe-3 ps-3'} style={{ border: '1px solid #CECECE', borderRadius: '15px' }}>
            <div className={'row'}>
              <div className="col-10">
                <ReservationTab
                  isReservationSearch={true}
                  form={form}
                  isAbroad={state.response.isAbroad}
                  setDisabled={setBannerDisabledButton}
                  onChangeForm={(meta) => setBannerForm(meta)}
                  name={state.response.planTab!}
                  employee={employee}
                  selectedLocation={state.response.selectedFloor}
                  selectedStartDate={state.response.startDate}
                  selectedEndDate={state.response.endDate}
                  selectStyle="col-lg-8 col-12 mb-2"
                  dateStyle="col-lg-4 col-12"
                  routingType={state.response.routingType}
                />
              </div>
              <div className="col-2 d-flex gap-2">
                <Button
                  disabled={bannerDisabledButton}
                  onClick={searchFloor}
                  style={{ height: '54px', borderRadius: '10px' }}
                  className={'w-100 text-center d-table-cell search-button'}>
                  {t('buttons.go-to-office')}
                </Button>

                <div className="d-flex align-items-start">
                  {AuthUtil.isAdmin(employee?.authList) && (
                    <FavoriteIconButton
                      outlined
                      isFavorite={favorite}
                      style={{ borderRadius: '5px' }}
                      onSave={handleAddFavorite}
                      onRemove={handleRemoveFavorite}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className={'row'}>
            <div className="col-12 col-lg-4">
              <div id="of-filter" className={state.response.selectedFloor == null ? 'of-filter pe-none' : 'of-filter'}>
                <div className="row">
                  <div
                    className={
                      !state.response.selectedFloor?.isReservable
                        ? 'd-flex align-items-center mb-3'
                        : 'd-flex align-items-center'
                    }>
                    <div className="floor-properties me-2">{t('overlaypanel-texts.this-floor-properties')}</div>
                    <div onMouseOver={(e) => showProperties(e)} onMouseLeave={(e) => hideProperties(e)}>
                      <i className="pi pi-info-circle"></i>
                    </div>
                    <OverlayPanel
                      ref={opProperties}
                      id="overlay_panel"
                      style={{ width: '250px' }}
                      className="properties-overlaypanel">
                      <div className="row">
                        <div className="col-4 properties-type">
                          <div className="properties-title">{t('overlaypanel-texts.location-properties')}</div>
                          {allFloorProperties?.LOCATION && allFloorProperties?.LOCATION.length > 0 ? (
                            allFloorProperties?.LOCATION.map((properties) => {
                              return <div>{t(`auth-properties.${properties.name}`)}</div>
                            })
                          ) : (
                            <p className="no-content-text">{t('overlaypanel-texts.location-warning')}</p>
                          )}
                        </div>
                        <div className="col-4 properties-type">
                          <div className="properties-title">{t('overlaypanel-texts.block-properties')}</div>
                          {allFloorProperties?.BLOCK && allFloorProperties.BLOCK.length > 0 ? (
                            allFloorProperties?.BLOCK.map((properties) => {
                              return <div>{t(`auth-properties.${properties.name}`)}</div>
                            })
                          ) : (
                            <p className="no-content-text">{t('overlaypanel-texts.block-warning')}</p>
                          )}
                        </div>
                        <div className="col-4">
                          <div className="properties-title">{t('overlaypanel-texts.floor-properties')}</div>
                          {allFloorProperties?.FLOOR && allFloorProperties.FLOOR.length > 0 ? (
                            allFloorProperties?.FLOOR.map((properties) => {
                              return <div>{t(`auth-properties.${properties.name}`)}</div>
                            })
                          ) : (
                            <p className="no-content-text">{t('overlaypanel-texts.floor-warning')}</p>
                          )}
                        </div>
                      </div>
                    </OverlayPanel>
                  </div>
                </div>

                <div className={!state.response.selectedFloor?.isReservable ? '' : 'd-none'}>
                  <div className="floor-properties-filter mb-4">{t('reservation.table-filters')}</div>
                  <div className="row">
                    {tableProperties?.length > 0 &&
                      tableProperties.map((property) => (
                        <div key={'property-' + property.id} className={'col-6'}>
                          <div className="p-field-checkbox">
                            <Checkbox
                              inputId={'property-' + property.id?.toString()}
                              name="category"
                              value={property}
                              className={property.isActive ? '' : 'pe-none'}
                              onChange={(e) => onPropertyChange(e, selectedPropertyList, setSelectedPropertyList)}
                              checked={selectedPropertyList.some((item: { id: number }) => item.id === property.id)}
                              disabled={!property.isActive}
                            />
                            <label
                              className={property.isActive ? 'mx-1' : 'disable-properties mx-1'}
                              htmlFor={'property-' + property.id?.toString()}>
                              {t(`table-properties.${property.name}`)}
                            </label>
                          </div>
                        </div>
                      ))}
                  </div>
                  <div className="mb-3">
                    <div className="row">
                      <div className="col-6">
                        <Button
                          disabled={state.response.selectedFloor == null}
                          onClick={() => setSelectedPropertyList([])}
                          className="p-button-outlined w-100"
                          label={t('buttons.clear')}
                        />
                      </div>
                      <div className="col-6">
                        <Button
                          disabled={state.response.selectedFloor == null}
                          className="w-100"
                          onClick={() => saveFilter()}
                          label={t('buttons.apply')}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <PersonnelList
                height={heightCalc() as number}
                isSelectEmployee={
                  state.response.endDate.getTime() !== state.response.startDate.getTime() ||
                  state?.response?.selectedFloor?.isReservable
                    ? true
                    : false
                }
                selectedFloor={state.response.selectedFloor ? true : false}
                data={personnelList!}
                onSelectEmployee={(employee) => {
                  setSelectEmployee((prevState) => ({
                    ...(prevState === employee ? null : employee),
                  }))
                }}></PersonnelList>
            </div>
            <div className="col-12 col-lg-8 of-desk-reservation">
              <DeskReservation
                search={search}
                loading={loading!}
                deskList={deskList!}
                floorTemplate={floorTemplate!}
                searchData={state.response}
                myReservation={myReservation!}
                selectedEmployee={selectEmployee}
                modalText={modalText}
                capacity={capacity!}
                getPlanTabNum={getPlanTabNum}
                onClick={(e: ISelectBox) => changeFloor(e)}></DeskReservation>
            </div>
          </div>
          <div className={'row'}>
            <div className={'col-12'}>
              {state.response.selectedFloor ? (
                mapsURL || mapsURL !== '' ? (
                  <div className="mt-4">
                    <iframe
                      title="map"
                      src={mapsURL}
                      width={'100%'}
                      height="250"
                      frameBorder="0"
                      style={{ border: '1px solid #CECECE !important', borderRadius: '15px' }}
                      allowFullScreen={true}
                      aria-hidden="false"
                      tabIndex={0}></iframe>
                  </div>
                ) : (
                  <div className={'h-100'}>
                    <div
                      className="unavailable-map-container"
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        height: '100%',
                      }}>
                      <i className="pi pi-info-circle unavailable-map-warning" />
                      <i className="map-error-text">{t('failed.map-error')}</i>
                    </div>
                  </div>
                )
              ) : (
                <div></div>
              )}
            </div>
          </div>
        </div>
      )}

      {visible && (
        <SharedOfficeModal visible={visible} setVisible={setVisible} messageTr={messageTr} dayList={dayList} />
      )}

      {floorCalendarVisible && (
        <SharedOfficeModal
          visible={floorCalendarVisible}
          setVisible={setFloorCalendarVisible}
          messageTr={floorCalendarMessage}
          dayList={floorDayList}
        />
      )}
    </Private>
  )
}

export default Reservation
